class InlineDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.panel = this.querySelector('.inline-drawer-panel');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    // Close any other open inline drawers first
    document.querySelectorAll('inline-drawer-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        const parentElement = details.closest('inline-drawer-menu');
        if (parentElement) parentElement.close();
      }
    });

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this._setHeaderPosition();
    this.mainDetailsToggle.setAttribute('open', '');
    // Use rAF to trigger transition after open attribute is set
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.mainDetailsToggle.classList.add('inline-drawer-opening');
        this.summary.setAttribute('aria-expanded', 'true');
        document.body.classList.add('inline-drawer-open');
      });
    });

    // Close on overlay click
    // this._overlayClickHandler = (e) => {
    //   if (e.target === this.summary) return;
    //   // Check if click is on the overlay (the ::before pseudo-element area)
    //   const rect = this.panel.getBoundingClientRect();
    //   if (e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
    //     this.close();
    //   }
    // };
     this._resizeHandler = this._setHeaderPosition.bind(this);
    window.addEventListener('resize', this._resizeHandler);

    // Close when clicking outside the panel
    this._outsideClickHandler = (e) => {
      if (!this.panel.contains(e.target) && !this.summary.contains(e.target)) {
        this.close();
      }
    };
    setTimeout(() => {
      document.addEventListener('click', this._outsideClickHandler);
    }, 100);
  }
  
  _setHeaderPosition() {
    const header = this.closest('.section-header') || document.querySelector('.section-header');
    if (header) {
      const headerBottom = header.getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--inline-drawer-top', `${Math.floor(headerBottom)}px`);
    }
  }

  close() {
    this.mainDetailsToggle.classList.remove('inline-drawer-opening');
    this.summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('inline-drawer-open');

    if (this._outsideClickHandler) {
      document.removeEventListener('click', this._outsideClickHandler);
      this._outsideClickHandler = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }

    // Wait for transition to complete before removing open attribute
    const handleTransitionEnd = () => {
      this.mainDetailsToggle.removeAttribute('open');
      this.panel.removeEventListener('transitionend', handleTransitionEnd);
    };

    this.panel.addEventListener('transitionend', handleTransitionEnd);

    // Fallback in case transitionend doesn't fire
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.mainDetailsToggle.removeAttribute('open');
      }
    }, 400);
  }
}

customElements.define('inline-drawer-menu', InlineDrawerMenu);
